<div class="sidebar-account" #container data-testid="sidebar-container" (click)="toggleMenu()" (keydown)="toggleMenu()">
  <aside (click)="$event.stopImmediatePropagation();" class="wrapper-menu">
    <div class="sidebar-account-menu">
      <div class="header-sidebar">
        <img src="./assets/images/core/icone-unico.svg" alt="unico | people" width="40" />
        <button type="button" aria-label="Fecha menu lateral" data-testid="back-button" (click)="toggleMenu()"></button>
      </div>
      <div class="sidebar-menu first">
        <h3 class="sidebar-account_subtitle">Empresa</h3>
        <ul>
          <li class="open-companies-container">
            <button
              class="open-companies-mini"
              type="button"
              data-testid="companies-button"
              (click)="handleCompaniesMenu()"
              attr.aria-label="Abrir aba de empresas da {{acc?.name}}."
            >
              <span class="current-company-mini-image" [attr.data-name]="acc?.name | slice:0:1">
                <img
                  *ngIf="acc?.customFields?.brand !== null"
                  src="{{url}}/t/200x200,q100/{{acc?.customFields?.brand?.path}}"
                  alt="Logo da empresa"
                />
              </span>
              <p class="current-company-mini-title" title="{{acc?.name}}">{{acc?.name}}</p>
            </button>
          </li>
          <li>
            <a
              routerLink="/"
              (click)="toggleMenu()"
              aria-label="Ir para listagem de candidatos."
              class="option-menu ico-admission"
              [ngClass]="{'isActive': isActivePath === 'admissions'}"
            >
              Admissão
            </a>
          </li>
          <li>
            <details class="collapse">
              <summary
                class="option-menu ico-signatures"
                [ngClass]="{'isActive': isActivePath === 'signatures'|| isActivePath === 'company/models-list' || isActivePath === 'company/models'}"
              >
                Assinaturas
              </summary>
              <ul>
                <li>
                  <a
                    routerLink="/signatures"
                    (click)="toggleMenu()"
                    aria-label="Ir para gestão de assinaturas."
                    class="option-menu"
                    [ngClass]="{'isActive': isActivePath === 'signatures'}"
                  >
                    Gestão de assinaturas
                  </a>
                </li>
                <li>
                  <a
                    *ngIf="!enableNewModelsList"
                    routerLink="/company/models"
                    (click)="toggleMenu()"
                    aria-label="Ir para gestão de modelos."
                    class="option-menu"
                    [ngClass]="{'isActive': isActivePath === 'company/models'}"
                  >
                    Gestão de modelos
                  </a>
                  <a
                    *ngIf="enableNewModelsList"
                    routerLink="/company/models-list"
                    (click)="toggleMenu()"
                    aria-label="Ir para gestão de modelos."
                    class="option-menu"
                    [ngClass]="{'isActive': isActivePath === 'company/models-list'}"
                  >
                    Gestão de modelos
                  </a>
                </li>
              </ul>
            </details>
          </li>
          <li>
            <details class="collapse">
              <summary class="option-menu ico-analytics" [ngClass]="{'isActive': isActivePath === 'analytics/admissions' || isActivePath === 'analytics/signatures'}">
                Analytics
              </summary>
              <ul>
                <li>
                  <a
                    routerLink="/analytics/admissions"
                    (click)="toggleMenu()"
                    aria-label="Ir para analytics de admissões."
                    class="option-menu"
                    [ngClass]="{'isActive': isActivePath === 'analytics/admissions'}"
                  >
                    Painel de admissões
                  </a>
                </li>
                <li>
                  <a
                    routerLink="/analytics/signatures"
                    (click)="toggleMenu()"
                    aria-label="Ir para analytics de assinaturas."
                    class="option-menu"
                    [ngClass]="{'isActive': isActivePath === 'analytics/signatures'}"
                  >
                    Painel de assinaturas
                  </a>
                </li>
              </ul>
            </details>
          </li>
          <li>
            <a
              routerLink="/company"
              data-testid="settings-button"
              (click)="toggleMenu()"
              aria-label="Ir para as configurações da empresa."
              class="option-menu ico-settings"
              [ngClass]="{'isActive': isActivePath === 'settings'}"
            >
              Configurações
            </a>
          </li>
        </ul>
      </div>
      <div class="sidebar-menu">
        <h3 class="sidebar-account_subtitle">Grupo</h3>
        <ul>
          <li *ngIf="hasSignature">
            <a (click)="redirectToSign()" aria-label="Ir para as configurações da empresa." class="option-menu ico-sign"> Unico Sign </a>
          </li>
        </ul>
      </div>
    </div>
    <div *ngIf="company" class="sidebar-company-submenu sidebar-submenu" data-testid="companies-container">
      <app-companies [companies]="list" [acc]="acc?.uid" (change)="changeCompany($event)"></app-companies>
    </div>
  </aside>
</div>
